export default __webpack_public_path__ + "static/aboutIdentity-80ad4e2e77d827a092891fea564b77c6.svg";